module.exports = __webpack_public_path__ + "img/p9.7fd268d0.png";